<script setup>
/**
 * @description 商城首页 Banner 业务组件
 * @reason 抽离通用逻辑至 BaseHomeBanner，本组件仅负责商城侧数据获取
 * @param {string|number|null} categoryId - 分类聚合页所属一级分类 ID
 * @emits empty - 当 banner 数据为空时触发，透传自 BaseHomeBanner
 */

// 1. Imports
import BaseHomeBanner from '~/components/base/HomeBanner.vue'
import { DISPLAY_PAGE } from '@/utils/constant'

const props = defineProps({
  displayPage: {
    type: Number,
    default: DISPLAY_PAGE.STORE_HOME,
  },
  categoryId: {
    type: [String, Number],
    default: null,
  },
  tracking: {
    type: Object,
    default: null,
  },
})

// 2. Emits
const emit = defineEmits(['empty'])
</script>

<template>
  <BaseHomeBanner
    :display-page="props.displayPage"
    :category-id="props.categoryId"
    :show-visual-overlay="false"
    :tracking="props.tracking"
    @empty="emit('empty', $event)"
  />
</template>
